import { paymentMethodRegistry } from "./strategies";
import type { PaymentMethodId, PaymentMethodStrategy, StorablePaymentMethodId } from "./types";

export type { PaymentMethodId, PaymentMethodStrategy, StorablePaymentMethodId } from "./types";
export { isStorablePaymentMethodId, STORABLE_PAYMENT_METHOD_IDS } from "./types";

export const DEFAULT_PAYMENT_METHOD_ID: StorablePaymentMethodId = "money";

const registryById = new Map<PaymentMethodId, PaymentMethodStrategy>(
  paymentMethodRegistry.map((strategy) => [strategy.id, strategy])
);

export function getPaymentMethod(id: PaymentMethodId): PaymentMethodStrategy {
  const strategy = registryById.get(id);
  if (!strategy) {
    throw new Error(`Unknown payment method: ${id}`);
  }
  return strategy;
}

export function availablePaymentMethods(acceptedIds?: PaymentMethodId[]): PaymentMethodStrategy[] {
  const checkoutMethods = paymentMethodRegistry.filter((strategy) => strategy.isAvailable());

  if (!acceptedIds || acceptedIds.length === 0) {
    return checkoutMethods;
  }

  const allowed = new Set<PaymentMethodId>(acceptedIds);
  return checkoutMethods.filter((strategy) => allowed.has(strategy.id));
}

export function resolveDefaultPaymentMethodId(acceptedIds: PaymentMethodId[]): PaymentMethodId {
  if (acceptedIds.includes(DEFAULT_PAYMENT_METHOD_ID)) {
    return DEFAULT_PAYMENT_METHOD_ID;
  }

  return acceptedIds[0] ?? DEFAULT_PAYMENT_METHOD_ID;
}

export function isPaymentMethodId(value: string): value is PaymentMethodId {
  return registryById.has(value as PaymentMethodId);
}
